import React, { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import { useAuth } from "../contexts/AuthContext";
import { supabase } from "../supabaseClient";
import Landing from "./Landing";
import PlayerHome from "./PlayerHome";

/**
 * Guest: marketing landing. Signed-in league member: player dashboard with fixtures.
 */
async function userHasLeagueTeam(user) {
  if (!user) return false;
  const { data: captain } = await supabase
    .from("league_teams")
    .select("id")
    .eq("captain_id", user.id)
    .order("created_at", { ascending: false })
    .limit(1)
    .maybeSingle();
  if (captain) return true;
  const { data: player } = await supabase
    .from("league_team_players")
    .select("id")
    .eq("user_id", user.id)
    .limit(1)
    .maybeSingle();
  if (player) return true;
  if (user.email) {
    const { data: byEmail } = await supabase
      .from("league_team_players")
      .select("id")
      .ilike("email", user.email)
      .limit(1)
      .maybeSingle();
    if (byEmail) return true;
  }
  return false;
}

const HomeRouter = () => {
  const { user, loading: authLoading } = useAuth();
  const [checked, setChecked] = useState(false);
  const [hasTeam, setHasTeam] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (authLoading) return;
      if (!user) {
        if (!cancelled) {
          setHasTeam(false);
          setChecked(true);
        }
        return;
      }
      const ok = await userHasLeagueTeam(user);
      if (!cancelled) {
        setHasTeam(ok);
        setChecked(true);
      }
    })();
    return () => { cancelled = true; };
  }, [user, authLoading]);

  if (authLoading || !checked) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 12, backgroundColor: "#fafafa" }}>
        <CircularProgress sx={{ color: "#000" }} />
      </Box>
    );
  }

  if (user && hasTeam) return <PlayerHome />;
  return <Landing />;
};

export default HomeRouter;
